export default [{
  path: '/companydoc/view',
  name: 'companydocument',
  component: () => import('@/app/company-document/CompanyDocumentView'),
  meta: {
    // resource: 'companydocs',
    // actions: ['read']
  }
}]
